import { BaseTypeaheadModal, MobileBaseTypeahead } from '../../../shared/views/typeaheads';
import { BaseFieldView } from '../BaseField/views';
import { SelectFieldSelections } from './models';

export const SelectFieldSelectorModal = BaseTypeaheadModal.extend({
    collection: null,
    collection_class: SelectFieldSelections,
    toolbarnav_title: function () {
        if (this.allow_multiple) {
            return _t('mobile_toolbarnav_title_select_multiple');
        }
        return _t('mobile_toolbarnav_title_select_one');
    },
    allow_multiple: true,

    all_options: null, // since this multiselect doesn't hit the server or a local cache (the options are saved in the model), we'll use this as our source

    initialize: function (options) {
        SelectFieldSelectorModal.__super__.initialize.apply(this, arguments);

        // When we call post_on_select(), let's make sure to send them an array instead of a collection:
        var _post_on_select = this.post_on_select;
        this.post_on_select = function (choices) {
            _post_on_select(choices.toJSON());
        };
    },

    /**
     * Override the normal typeahead search to just search our select field options and update our
     * collection with those that match.
     */
    search: function (query) {
        // Filter by the search query
        var filtered = $.grep(this.all_options, function (search_option) {
            if (!query) {
                return true;
            } // show everything
            return search_option.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });

        this.collection.reset();
        this.collection.add(filtered);
        this.register_selected_results();
    }
});

export const SelectFieldTypeahead = MobileBaseTypeahead.extend({
    model: null, // SelectFieldSelections.model
    collection_class: SelectFieldSelections,
    modal_class: SelectFieldSelectorModal,
    allow_multiple: true,
    all_options: null, // used for select field as a source to search on in the modal

    get_default_value: function () {
        return '';
    },

    initialize: function (options) {
        SelectFieldTypeahead.__super__.initialize.apply(this, arguments);

        // Make sure our on_item_removed() returns JSON instead of a collection
        var _on_item_removed = this.on_item_removed;
        this.on_item_removed = function (collection) {
            _on_item_removed(collection.toJSON());
        };
    },

    get_modal_options: function () {
        return $.extend(SelectFieldTypeahead.__super__.get_modal_options.apply(this, arguments), {
            all_options: this.all_options
        });
    }
});

export const SelectFieldView = BaseFieldView.extend({
    selections: null, // SelectFieldSelections

    templateHelpers: function () {
        var super_helpers = SelectFieldView.__super__.templateHelpers.apply(this, arguments);
        return $.extend(super_helpers, {
            allow_multiselect: this.model.get('metadata') && !!this.model.get('metadata').is_multiple_choices
        });
    },

    // for multi-select:
    regions: {
        r_select_field_typeahead: '.field_value'
    },

    events: {
        'change select.saveonchange': 'save_value'
    },

    onRender: function () {
        if (!this.templateHelpers().allow_multiselect) {
            return;
        }
        var this_ = this;

        this.r_select_field_typeahead.show(
            new SelectFieldTypeahead({
                get_current_selections: function () {
                    return this_.model.get('value'); // SelectFieldTypeahead will convert this to a collection
                },
                all_options: this.model.get('options'),
                post_on_select: function (choices) {
                    this_._save_value(choices);
                    if (!this_.isClosed) {
                        this_.render();
                    } // needed for web only
                },
                on_item_removed: function (all_choices) {
                    this_._save_value(all_choices);
                }
            })
        );
    },

    save_value: function (event) {
        this._save_value($(event.target).val());
    },

    /**
     * Save the value in the proper format: array if there's a value, '' if not
     */
    _save_value: function (new_val) {
        if (new_val && !(new_val instanceof Array)) {
            new_val = [new_val];
        }

        this.$el.removeClass('invalid'); // innocent until proven guilty
        this.model.set('value', new_val);
        this.model.isValid(true); // validate separately so even if the value is incorrect, it is consistent with the UI
    }
});
